export const gENDateFormat = [
  "January 28, 2016",
  "28 January 2016",
  "28 Jan 2016",
  "1/28/2016",
  "1-28-2016",
  "1.28.2016",
  "1/28/16",
  "01-28-16",
  "01.28.16",
  "28/01/2016",
  "28-01-2016",
  "28.01.2016",
  "28/01/16",
  "28-01-16",
  "28.01.16",
  "01-2016",
  "January 2016",
  "January-2016",
  "28 (day)",
  "1 (month)",
  "January",
  "2016 (year)",
  "2016/01/28",
  "20160128",
  "2016-01-28"
];

export const gFRDateFormat = [
  "janvier 28, 2016",
  "28 janvier 2016",
  "28 janv 2016",
  "01/28/2016",
  "01-28-2016",
  "01.28.2016",
  "01/28/16",
  "01-28-16",
  "01.28.16",
  "28/01/2016",
  "28-01-2016",
  "28.01.2016",
  "28/01/16",
  "28-01-16",
  "28.01.16",
  "01-2016",
  "janvier 2016",
  "janvier-2016",
  "28 (jour)",
  "1 (mois)",
  "janvier",
  "2016 (an)",
  "2016/01/28",
  "20160128",
  "2016-01-28"
];

export const gESDateFormat = [
  "enero 28, 2016",
  "28 enero 2016",
  "28 ene 2016",
  "1/28/2016",
  "1-28-2016",
  "1.28.2016",
  "1/28/16",
  "01-28-16",
  "01.28.16",
  "28/01/2016",
  "28-01-2016",
  "28.01.2016",
  "28/01/16",
  "28-01-16",
  "28.01.16",
  "01-2016",
  "enero 2016",
  "enero-2016",
  "28 (día)",
  "1 (mes)",
  "enero",
  "2016 (año)",
  "2016/01/28",
  "20160128",
  "2016-01-28"
];

export const gDEDateFormat = [
  "Januar 28, 2016",
  "28 Januar 2016",
  "28 Jan 2016",
  "1/28/2016",
  "1-28-2016",
  "1.28.2016",
  "1/28/16",
  "01-28-16",
  "01.28.16",
  "28/01/2016",
  "28-01-2016",
  "28.01.2016",
  "28/01/16",
  "28-01-16",
  "28.01.16",
  "01-2016",
  "Januar 2016",
  "Januar-2016",
  "28 (Tag)",
  "1 (Monat)",
  "Januar",
  "2016 (Jahr)",
  "2016/01/28",
  "20160128",
  "2016-01-28"
];
